import React from 'react'
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from 'components/ui/tooltip'
import { getDocumentIcon } from '../utils/getDocumentIcon'

interface DocumentAvatarProps {
	filename: string | null | undefined
	onClick?: () => void
	size?: number
	tooltipText?: string
	/**
	 * Accepted but intentionally unused. The list/detail endpoints embed
	 * a presigned `thumbnailUrl` and we used to render it here as a mini
	 * preview, but stakeholder feedback preferred the colored file-type
	 * badge — it's faster to scan a long list when every avatar follows
	 * the same visual shape. The prop is retained so the row component
	 * doesn't need to change.
	 */
	thumbnailUrl?: string | null
}

const DocumentAvatar: React.FC<DocumentAvatarProps> = ({
	filename,
	onClick,
	size = 40,
	tooltipText = 'Click to preview.',
}) => {
	const icon = getDocumentIcon(filename)
	const handleClick: React.MouseEventHandler = e => {
		e.stopPropagation()
		onClick?.()
	}
	const handleKey: React.KeyboardEventHandler = e => {
		if (!onClick) return
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault()
			e.stopPropagation()
			onClick()
		}
	}

	return (
		<TooltipProvider delayDuration={300}>
			<Tooltip>
				<TooltipTrigger asChild>
					<button
						type="button"
						aria-label={tooltipText}
						onClick={handleClick}
						onKeyDown={handleKey}
						className="inline-flex items-center justify-center rounded text-white font-semibold focus:outline-none focus:ring-2 focus:ring-[#0080fe] focus:ring-offset-1"
						style={{
							width: size,
							height: size,
							backgroundColor: icon.color,
							fontSize: Math.max(9, Math.floor(size * 0.22)),
						}}
					>
						{icon.label}
					</button>
				</TooltipTrigger>
				<TooltipContent className="bg-white text-[#0080fe] shadow-lg text-[11px]">
					{tooltipText}
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	)
}

export default DocumentAvatar
